import { PlaceCard } from "/src/components/PlaceCard";
import { getImage } from "gatsby-plugin-image";
import * as React from 'react';
export default {
  PlaceCard,
  getImage,
  React
};